
import { Component, Vue, Ref } from 'vue-property-decorator'
import { ReporterService } from '@/services'
import AddNewsTable from './components/news_table.vue'
import reporterService from '@/services/reporter-service'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

@Component({
    name: 'reporter-news',
    components: {
        AddNewsTable,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private newsList = []
    private pageIndex = 1
    private pageSize = 15
    private status = 0
    private pageTotal = 0
    private statusOptions = [
        { value: 0, label: '全部' },
        { value: 1, label: '未通过' },
        { value: 2, label: '已通过' },
        { value: 3, label: '不用管' },
        { value: 4, label: '已处理' }
    ]
    private sort = 'created_at'
    private sortOptions = [
        { value: 'created_at', label: '创建时间' },
        { value: 'updated_at', label: '更新时间' }
    ]
    private isLoading = false
    private loadingText = ''

    private mounted() {
        this.getNewsList()
    }

    private async getNewsList() {
        const params = {
            status: this.status,
            sort: this.sort,
            page_size: this.pageSize,
            page_index: this.pageIndex
        }
        this.isLoading = true
        const result = await ReporterService.getAddNewsList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.newsList = result.data.list
        }
    }

    private onCurrentChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getNewsList)
    }

    private async onNewsTableChange(option: {row: any, status: number}) {
        const params = { id: option.row.id, status: option.status }
        const result = await reporterService.updateAddNewsStatus(params)
        if (result.status === 200) {
            option.row.status = option.status
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '发生错误，修改失败')
    }
}
